module.exports = "data:application/vnd.ms-fontobject;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmb250cy9nbHlwaGljb25zLWhhbGZsaW5ncy1yZWd1bGFyLWY0NzY5Zi5lb3QiOw=="


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module id = 789
// module chunks = 2